module.exports = __webpack_public_path__ + "static/img/manual-24.d216907.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-24.png
// module id = JcNh
// module chunks = 4